import type { FormDefData } from '../../Utils/types';
import { STRING, UI_TYPE_TIME } from './FormTypes';

const formDef: FormDefData = {
  formId: 'BloodWorkSent',
  behaviors: {
    lockWhenFinalized: true,
    saveOnComplete: true,
    clearOnIncomplete: true,
    clearOnNotApplicable: true,
  },
  sections: [
    {
      id: 1,
      title: '',
      fields: [
        {
          id: 1,
          fieldName: 'clinicalEventTime',
          displayAs: 'Blood Work Sent at',
          title: 'Time',
          type: STRING,
          uiType: UI_TYPE_TIME,
          isTime: true,
          mandatory: true,
          tags: [],
        },
      ],
    },
  ],
};

export default formDef;
